import { cashbackApi } from '../../api'

const asArray = (res) => (Array.isArray(res?.data) ? res.data : [])
const asData = (res) => res?.data


export const getBranches = (config) =>
	cashbackApi.get('branches', config).then(asArray)

export const createBranch = (name) =>
	cashbackApi.post('branches', { name: name.trim() }).then(asData)

export const updateBranch = (id, name) =>
	cashbackApi.put(`branches/${id}`, { name: name.trim() }).then(asData)

export const deleteBranch = (id) => cashbackApi.delete(`branches/${id}`)


export const getInstallmentSettings = (branchId, config) =>
	cashbackApi
		.get('installment-settings', {
			params: branchId ? { branchId } : undefined,
			...config,
		})
		.then(asArray)

const toSettingBody = ({ branchId, monthCount, rate }) => ({
	branchId,
	monthCount: Number(monthCount),
	rate: Number(rate),
})

export const createInstallmentSetting = (body) =>
	cashbackApi
		.post('installment-settings', toSettingBody(body))
		.then(asData)

export const updateInstallmentSetting = (id, body) =>
	cashbackApi
		.put(`installment-settings/${id}`, toSettingBody(body))
		.then(asData)

export const deleteInstallmentSetting = (id) =>
	cashbackApi.delete(`installment-settings/${id}`)
